import { purple, green, magenta } from '@ant-design/colors'
import formatIntegerBySpace from '../../../../helpers/formatters/format-integer-by-space'
import {
    validateCostOfAllCopies,
    validateProfitOfAllCopies,
    validateProfitPerHour,
} from '../../helpers/validators'
import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const calculatedMoneyColumns: CalculationColumn[] = [
    {
        dataIndex: ['calculated', 'money'],
        title: 'Деньги',
        // @ts-ignore
        children: [
            {
                dataIndex: ['calculated', 'costOfOneLabel'],
                title: 'Себест. 1 шт',
                width: 46,
                onCell: (record: any) => ({
                    ...onAnyStandardCell(record),
                    style: { fontWeight: '600' },
                }),
                render: renderCalcPos(r => {
                    if (r.shipmentType === 'colorProof') return null
                    return (
                        Math.round(((r.calculated?.costOfAllCopies || 0) / (r.copies || 1)) * 100) /
                        100
                    )
                }),
            },
            {
                dataIndex: ['calculated', 'costOfAllCopies'],
                title: 'Себестоимость тиража',
                width: 80,
                onHeaderCell: () => ({
                    style: {
                        backgroundColor: purple[1],
                    },
                }),
                onCell: (record: any) => {
                    return {
                        ...onAnyStandardCell(record),
                        style: {
                            backgroundColor: purple[1],
                            fontWeight: '600',
                        },
                    }
                },
                render: renderCalcPos(r => {
                    if (r.shipmentType === 'colorProof') return null
                    return formatIntegerBySpace(Math.round(r.calculated?.costOfAllCopies || 0))
                }),
            },
            {
                dataIndex: ['calculated', 'profitOfAllCopies'],
                title: 'Прибыль с тиража',
                width: 80,
                validator: validateProfitOfAllCopies,
                onHeaderCell: () => ({
                    style: {
                        backgroundColor: green[1],
                    },
                }),
                onCell: (record: any) => {
                    return {
                        ...onAnyStandardCell(record),
                        style: {
                            backgroundColor: green[1],
                            fontWeight: '600',
                        },
                    }
                },
                render: renderCalcPos(r => {
                    if (r.shipmentType === 'colorProof') return null
                    return formatIntegerBySpace(Math.round(r.calculated?.profitOfAllCopies || 0))
                }),
            },
            {
                dataIndex: ['calculated', 'turnover'],
                title: 'Итого за тираж',
                width: 80,
                onHeaderCell: () => ({
                    style: {
                        backgroundColor: magenta[1],
                    },
                }),
                onCell: (record: any) => {
                    return {
                        ...onAnyStandardCell(record),
                        style: {
                            backgroundColor: magenta[1],
                            fontWeight: '600',
                        },
                    }
                },
                render: renderCalcPos(r =>
                    formatIntegerBySpace(Math.round(r.calculated?.turnover || 0))
                ),
            },
            {
                dataIndex: ['calculated', 'profitPerHour'],
                title: 'Прибыль в 1 час',
                width: 80,
                validator: validateProfitPerHour,
                onCell: onAnyStandardCell,
                render: renderCalcPos(r => {
                    if (r.shipmentType === 'colorProof') return null
                    return formatIntegerBySpace(Math.round(r.calculated?.profitPerHour || 0))
                }),
            },
        ],
    },
]
